import UserStore from '../Stores/UserStore'
import { observable, action } from 'mobx'
import * as _ from 'lodash'

export interface INavItem {
    label: string
    link: string
    className?: string
    title: string
}

export class NavItem implements INavItem {
    label: string
    link: string
    className: string
    title: string

    constructor(anchor: string, acceptor: string, className?: string, title?: string) {
        this.label = anchor
        this.link = acceptor
        this.className = className ? className : ''
        this.title = title ? title : ''
    }
}

export class Nav {
    @observable
    public items: Array<NavItem>

    private static _instance: Nav

    public static getInstance(): Nav {
        return this._instance || (this._instance = new this())
    }

    private constructor() {
        this.init()
        this.addRoleDependentItems()
    }

    init() {
        this.items = []
    }

    @action.bound
    addRoleDependentItems() {
        const us = UserStore.getInstance()

        let data: Array<NavItem> = []
        
        if (us.checkAdmin || us.checkSuperAdmin) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('TroubleEvents', '/troubleevents', 'troubleevents', 'troubleevents'))
            data.push(new NavItem(
                'TroubleEventsHistory', 
                '/troubleEventsHistory', 
                'troubleEventsHistory', 
                'troubleEventsHistory')
            )
            data.push(new NavItem('Users', '/users', 'users', 'users'))
            data.push(new NavItem('Reports', '/reports', 'reports', 'reports'))
            data.push(new NavItem('Settings', '/settings', 'settings', 'settings'))
            data.push(new NavItem('Merchants', '/merchants', 'merchants', 'merchants'))
            data.push(new NavItem('Affiliates', '/affiliates', 'affiliates', 'affiliates'))
            data.push(new NavItem('Payments', '/payments', 'payments', 'payments'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        if (us.checkCreditConsultant) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        if (us.checkCreditExpert) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('Payments', '/payments', 'payments', 'payments'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        if (us.checkCaller) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('TroubleEvents', '/troubleevents', 'troubleevents', 'troubleevents'))
            data.push(new NavItem(
                'TroubleEventsHistory', 
                '/troubleEventsHistory', 
                'troubleEventsHistory', 
                'troubleEventsHistory')
            )
        }

        if (us.checkHardCaller) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('TroubleEvents', '/troubleevents', 'troubleevents', 'troubleevents'))
            data.push(new NavItem(
                'TroubleEventsHistory', 
                '/troubleEventsHistory', 
                'troubleEventsHistory', 
                'troubleEventsHistory')
            )
        }

        if (us.checkCollector) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('TroubleEvents', '/troubleevents', 'troubleevents', 'troubleevents'))
            data.push(new NavItem(
                'TroubleEventsHistory', 
                '/troubleEventsHistory', 
                'troubleEventsHistory', 
                'troubleEventsHistory')
            )
        }

        if (us.checkLawyer) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('TroubleEvents', '/troubleevents', 'troubleevents', 'troubleevents'))
            data.push(new NavItem(
                'TroubleEventsHistory', 
                '/troubleEventsHistory', 
                'troubleEventsHistory', 
                'troubleEventsHistory')
            )
        }

        if (us.checkLogisticsAgent) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
        }

        if (us.checkCashier) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Payments', '/payments', 'payments', 'payments'))
        }

        if (us.checkCashierAdmin) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Payments', '/payments', 'payments', 'payments'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        if (us.checkCreditGroupAdministrator) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('Users', '/users', 'users', 'users'))
            data.push(new NavItem('Reports', '/reports', 'reports', 'reports'))
            data.push(new NavItem('Payments', '/payments', 'payments', 'payments'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        if (us.checkCollectionGroupAdministrator) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('Workspace', '/questionnaires', 'workspace', 'workspace'))
            data.push(new NavItem('History', '/history', 'history', 'history'))
            data.push(new NavItem('TroubleEvents', '/troubleevents', 'troubleevents', 'troubleevents'))
            data.push(new NavItem(
                'TroubleEventsHistory', 
                '/troubleEventsHistory', 
                'troubleEventsHistory', 
                'troubleEventsHistory'))
            data.push(new NavItem('Users', '/users', 'users', 'users'))
            data.push(new NavItem('Reports', '/reports', 'reports', 'reports'))
            data.push(new NavItem('Payments', '/payments', 'payments', 'payments'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        if (us.checkCatalogProductAdministrator) {
            data.push(new NavItem('Dashboard', '/dashboard', 'dashboard', 'dashboard'))
            data.push(new NavItem('CatalogProducts', '/catalogProducts', 'catalogProducts', 'catalogProducts'))
        }

        this.items = _.uniqBy(data, 'link')

        this.items.push(new NavItem('Search', '/externalData/search', 'search', 'search'))
        
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/Nav.ts